import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { WorkingCopyBackupService } from '../common/workingCopyBackupService.js';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { joinPath } from 'vscode/vscode/vs/base/common/resources';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { BrowserWorkingCopyBackupTracker } from './workingCopyBackupTracker.js';

let BrowserWorkingCopyBackupService = class BrowserWorkingCopyBackupService extends WorkingCopyBackupService {
    constructor(contextService, environmentService, fileService, logService) {
        super(joinPath(environmentService.userRoamingDataHome, 'Backups', contextService.getWorkspace().id), fileService, logService);
    }
};
BrowserWorkingCopyBackupService = ( __decorate([
    ( __param(0, IWorkspaceContextService)),
    ( __param(1, IWorkbenchEnvironmentService)),
    ( __param(2, IFileService)),
    ( __param(3, ILogService))
], BrowserWorkingCopyBackupService));
registerWorkbenchContribution2(BrowserWorkingCopyBackupTracker.ID, BrowserWorkingCopyBackupTracker, 1 );

export { BrowserWorkingCopyBackupService };
